// accordion.js

function setupAccordion(
    accordionSelector = ".js-accordion",
    boxSelector = ".accordion__box",
    activeClass = "active",
    callback = null
) {
    $(accordionSelector).each(function () {
        var elm = $(this);
        if (elm.hasClass(activeClass)) {
            elm.next(boxSelector).show();
        }
    });

    $(accordionSelector).on("click", function () {
        var elm = $(this);
        if (elm.next(boxSelector).is(":visible")) {
            elm.removeClass(activeClass)
                .next(boxSelector)
                .slideUp(300, function () {
                    if (typeof callback === "function") callback();
                });
        } else {
            elm.next(boxSelector).slideDown(300, function () {
                if (typeof callback === "function") callback();
            });
            elm.addClass(activeClass);
        }
    });
}

function initAccordion(
    accordionSelector = ".accordion",
    boxSelector = ".accordionBox",
    activeClass = "active",
    callback = null
) {
    document.querySelectorAll(accordionSelector).forEach((elm) => {
        const box = elm.nextElementSibling;
        if (!box || !box.matches(boxSelector)) return;

        if (elm.classList.contains(activeClass)) {
            $(box).stop(true, true).show();
        } else {
            $(box).stop(true, true).hide();
        }
    });

    document.addEventListener("click", (e) => {
        const elm = e.target.closest(accordionSelector);
        if (!elm) return;

        const box = elm.nextElementSibling;
        if (!box || !box.matches(boxSelector)) return;

        $(box).stop(true, true);

        if (elm.classList.contains(activeClass)) {
            elm.classList.remove(activeClass);
            $(box).slideUp(300, function () {
                if (typeof callback === "function") callback();
            });
        } else {
            elm.classList.add(activeClass);
            $(box).slideDown(300, function () {
                if (typeof callback === "function") callback();
            });
        }
    });
}

export { setupAccordion, initAccordion };
